export default "__VITE_ASSET__CNUuCKff__"